import { main } from "./main";
import { edmundston } from "./edmundston";
import { moncton } from "./moncton";
import { fredericton } from "./fredericton";
import { bathurst } from "./bathurst";
import { campbellton } from "./campbellton";
import { saintJohn } from "./saintjohn";
import { miramichi } from "./miramichi";
import { shippagan } from "./shippagan";



export const locales = [
    main,
    edmundston.en,
    edmundston.fr,
    moncton.en,
    moncton.fr,
    fredericton.en,
    fredericton.fr,
    bathurst.en,
    bathurst.fr,
    campbellton.en,
    campbellton.fr,
    saintJohn.en,
    saintJohn.fr,
    miramichi.en,
    miramichi.fr,
    shippagan.en,
    shippagan.fr,
];


export const areasArray = [
    {city:"Moncton",link:"/moncton/",coordinate:{lat: 46.10570123405835, lng: -64.6420570846559 }},
    {city:"Fredericton",link:"/fredericton/",coordinate:{lat: 45.96412956570109, lng: -66.65031444232824 }},
    {city:"Edmundston",link:"/edmundston/",coordinate:{lat: 47.37640844168513, lng: -68.32273754236337 }}, 
    // {city:"Grand Falls",link:"/grandfalls/",coordinate:{lat: 47.05297057932563, lng: -67.73408293192934 }},
    {city:"Bathurst",link:"/bathurst/",coordinate:{lat: 47.6256517361209, lng: -65.6685317749854 }},
    {city:"Miramichi",link:"/miramichi/",coordinate:{lat: 47.03238569017341, lng: -65.46292607642941 }}, 
    {city:"Shippagan",link:"/shippagan/",coordinate:{lat: 47.74235672306372, lng: -64.72204750794164 }},    
    {city:"Campbellton",link:"/campbellton/",coordinate:{lat: 47.97608816309709, lng: -66.45778943743699 }},
    {city:"Saint John",link:"/saintjohn/",coordinate:{lat: 45.3243043240747, lng: -65.95455983274093 }} 
];

export const comingSoon = [
    // {city:"Halifax",coordinate:{lat: 44.65718244031148, lng: -63.58570992136952 }},
    // {city:"Charlottetown",coordinate:{lat: 46.238285374393946, lng: -63.131222647224114 }}, 
    {city:"Woodstock",coordinate:{lat: 46.151073095272494, lng:  -67.5977837335316 }}, 
];


